module.exports = __webpack_public_path__ + "static/car.31c78ac1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Speakers/Background/car.svg
// module id = 715
// module chunks = 213534597649335